import {
  HISTORY_FETCH_REQUEST,
  HISTORY_FETCH_SUCCESS,
  HISTORY_FETCH_FAILURE,
  HISTORY_SET_MOTIVO_FILTER,
  HISTORY_PAGE_SIZE
} from './historyActions'

const INITIAL_STATE = {
  itens: [],
  total: 0,
  totalItens: 0,
  totalPaginas: 0,
  pageId: 1,
  pageSize: HISTORY_PAGE_SIZE,
  filtros: {
    dataInicial: '',
    dataFinal: '',
    motivoconcluido: 'todos'
  },
  resumo: null,
  loading: false,
  loaded: false,
  error: null
}

export default (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case HISTORY_FETCH_REQUEST:
      return {
        ...state,
        loading: true,
        loaded: false,
        error: null
      }

    case HISTORY_FETCH_SUCCESS:
      return {
        ...state,
        loading: false,
        loaded: true,
        error: null,
        itens: action.payload.itens,
        total: action.payload.total,
        totalItens: action.payload.totalItens,
        totalPaginas: action.payload.totalPaginas,
        pageId: action.payload.pageId,
        pageSize: action.payload.pageSize,
        resumo: action.payload.resumo,
        filtros: action.payload.filtros
      }

    case HISTORY_FETCH_FAILURE:
      return {
        ...state,
        loading: false,
        loaded: true,
        error: action.payload
      }

    case HISTORY_SET_MOTIVO_FILTER:
      return {
        ...state,
        filtros: {
          ...state.filtros,
          motivoconcluido: action.payload || 'todos'
        }
      }

    default:
      return state
  }
}